// @ts-nocheck
import React, { useCallback } from 'react';
import {
  Box,
  Dialog,
  Grid,
  IconButton,
  Typography,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import DialogTransition from '../Transition/DialogTransition';
import { NOOP } from '../../../const/CommonConst';

const ConfirmModal = ({
  open = false,
  handleClose = NOOP,
  confirm = NOOP,
  cancel = () => {
    handleClose();
  },
  alertLabelText = '',
  confirmButtonLabel = 'Yes',
  cancelButtonLabel = 'No',
  resourceName = '',
  hideConfirmButton = false,
}) => {
  const onClose = useCallback(
    (e) => {
      e?.stopPropagation();
      handleClose();
    },
    [handleClose]
  );

  return (
    <Box>
      <Dialog
        maxWidth="xs"
        open={open}
        onClose={onClose}
        TransitionComponent={DialogTransition}
      >
        <DialogTitle>
          <Box component="span" aria-live="polite" aria-atomic="true">
            {resourceName || ''}
          </Box>
        </DialogTitle>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          title="Close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container>
            <Grid
              item
              xs={12}
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={3}
            >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                mt={1}
              >
                <Typography variant="body1" align="center">
                  {alertLabelText}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box display="flex" gap={1}>
            {!hideConfirmButton && (
              <Button
                onClick={confirm}
                variant="outlined"
                title={confirmButtonLabel}
                size="small"
              >
                {confirmButtonLabel}
              </Button>
            )}
            <Button
              variant="contained"
              title={cancelButtonLabel}
              onClick={cancel || handleClose}
              size="small"
            >
              {cancelButtonLabel}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  cancel: PropTypes.func,
  alertLabelText: PropTypes.string.isRequired,
  cancelButtonLabel: PropTypes.string.isRequired,
  confirmButtonLabel: PropTypes.string.isRequired,
  resourceName: PropTypes.string.isRequired,
  hideConfirmButton: PropTypes.bool.isRequired,
};

export default ConfirmModal;
